export const appElement = 'afRegister';
